import React, { useEffect, useRef, useState } from 'react';
import axios from '../../utils/axiosExt';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Button from '../../components/common/Button';
import LeftNavBar from './LeftNavBar';
import OverView from './OverView';
import BadgesComponent from './../../components/common/Badges';
import BreadcrumbComponent from './../../components/common/Breadcrumb';
import { useLocation } from 'react-router-dom';
import Pencil from './../../assets/svg/pencil.svg';
import NationalEmblem from './../../assets/svg_main/national_emblem.svg';
import BackArrowsvg from './../../assets/svg_main/BackArrowIconSvg.svg';
import UserManagementHealthProvider from './OverView/UserManagementHealthProvider'
import './AppWrapperViewComponent.css';
import { BsPencil } from 'react-icons/bs';
import { RootState } from '@store/reducers';
import { useDispatch, useSelector } from 'react-redux';
import { resetForm } from '../../store/actions/userManagementAction';
import convertByteToImageURL from './../../utils/convertByteToImageURL';
import profilePic from '../../assets/png/default_profile.png';
import endpoints from './../../config/endpoints';

import UserManagementUpdate, { ChildComponentHandlerUpdateUser } from './OverView/UserManagementUpdate';
import { CommonHamburgar } from '@components/common/CommonHamburgar';
import { use } from 'i18next';
import Auth from "../../utils/auth";

import PrivilegeDetails from '@pages/UserManagement/PrivielegeDetails';
import { getData, getDataWithCache, postDataJSON } from '../../services/CommonApiService';
import { toast } from 'react-toastify';
import Credentials from '@pages/UserManagement/Credentials';
import { errorLogger } from '@utils/applicationLogUtils';
interface UserComponentProps {
  page: string;
  flow: string;
}

const UserViewComponent = (props: UserComponentProps) => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { page, flow } = props;
  const [user, setUser] = useState(JSON.parse(state));
  const [expend, setExpand] = useState(false)
  const [currentTab, setCurrentTab] = useState('Overview');
  const childRef = useRef<ChildComponentHandlerUpdateUser| null>(null)
  const [imageURL, setImageURL] = useState<string>('');
  const [tabs, setTabs] = useState<any>([]);
  const userStatus =  useSelector((state: RootState) => state.user.userStatusUpdate);
  const [roleDetails, setRoleDetails] = useState({});
  const role_payload = useSelector((state: RootState) => state.user.role_payload);
  const compositeRoleId = useSelector((state: RootState) => state.user.compositeRoleId);

  const handleChange = (e: any, key: string) => {
    setUser((prevState: any) => {
      return {
        ...prevState,
        [key]: e
      }
    })
  }
  const buttonName = flow === 'view' ? 'Edit Details' : 'Submit'
  const icon = buttonName === 'Edit Details' ? <Pencil /> : ''

  const isUserActive = useSelector((state: RootState) => state.user.isUserActive);
  // const saveHandler = () => {
  //   
  //   axios.put(`http://localhost:3020/userList/${user.id}`, user).then(res => {
  //     navigate(`/user-management`);
  //   });
  // }

  useEffect(() => {
    if (user && user.user_id) {
      axios.get(`${endpoints.getImageByUserID(user.user_id)}`,Auth.loggedIn()).then((res:any) => {
        
        if (res?.data?.data[0]) {
          const imageurl = convertByteToImageURL(res.data.data[0].image.data);
          setImageURL(imageurl);
        }
      }).catch((error: any) => {
      }).catch((error: any) => {
        
      })
    }

  }, [user,isUserActive]);

  const notHealthProviderList: any = ['Hospital Adminstrator - DH and SDH', 'Hospital Administrator - Other Central government hospitals', 'Medical Director', 'Medical Supritendent'];
  const showHealthProviderList : any = ['ASHA'];

  useEffect(() => {
    // const LoggedInUserType:any = localStorage.getItem('userTypeName');
    // if (LoggedInUserType === 'Super Admin User' && (user.usertype_name === 'Facility Level User' || user.usertype_name === 'Field Level User') && !notHealthProviderList.includes(user.user_designation_name)) {
    //   setTabs(['Overview', 'Privileges', 'Credentials', 'Health Provider Maintenance']);
    // }
    // else if (LoggedInUserType !== 'Super Admin User' && (user.usertype_name === 'Facility Level User' || user.usertype_name === 'Field Level User')  && showHealthProviderList.includes(user.user_designation_name)) {
    //   setTabs(['Overview', 'Privileges', 'Credentials', 'Health Provider Maintenance']);
    // }
    if ((user.usertype_name === 'Facility Level User' && !notHealthProviderList.includes(user.user_designation_name)) || (user.usertype_name === 'Field Level User' && showHealthProviderList.includes(user.user_designation_name))) {
      setTabs(['Overview', 'Privileges', 'Credentials', 'Health Provider Maintenance']);
    }
    else {
      setTabs(['Overview', 'Privileges', 'Credentials']);
    }

    getPrivilegesList();
  }, []);

  useEffect(() => {
      getPrivilegesList();
  }, [flow]);

  const getPrivilegesList = async () => {
    try {
      const userRolesResponse = await getDataWithCache<any[]>(`${endpoints.getCompositeRoleByUser}/${user.user_id}`);
      // const consolidatedPrivilegesResponse = await getData<any[]>(`${endpoints.getConsolidatedPrivilegesByUserId}/${user.user_id}`);
      const compositeRoleIds = userRolesResponse.data.map((item: any) => 
        {
          return {
          compositeRoleId: item.composite_role_id,
          role_name: item.role_name
        }
      });
      const roleDetails = {
        user_type: user.usertype_name,
        user_designation: user.user_designation_name,
        status: 'Enabled',
        user_id: user.user_id,
        compositeRoleIds: compositeRoleIds,
        description:"Test"
      };
      
      setRoleDetails(roleDetails);
    } catch(error:any){
      errorLogger(error?.response?.data||error?.response||error)
    }
  };
  
  const updateHandlerUpdate = () => {
    if (currentTab!== 'Privileges' && childRef.current) {      
      childRef.current.handleUpdateSave();
    }
    if(currentTab === 'Privileges'){
      handlePrivilegeSave();
    }
  }

  const handlePrivilegeSave = async () => {
    try{
      const privilePayload = {
        privilegeId : role_payload,
        userId: user.user_id,
        compositeRoleId: compositeRoleId
      }
      await postDataJSON<any>(`${endpoints.customiseUserPrivileges}`, privilePayload);

      toast.success("User Role Privileges have been successfully updated", {
        position: "top-center"
      });
    }
    catch(error:any){
      errorLogger(error?.response?.data||error?.response||error)
    }
  }
  const dispatch = useDispatch();
  useEffect(()=>{
    if(!isUserActive){
      user.user_status='Inactive'
    }
  },[isUserActive]);

  const handleBack = () => {
    dispatch(resetForm());
  }
  

  const closeButton = () => setExpand(false)

  return (
    <div className="app-view-wrapper">
      <header className="view-header">
        <div className="logo-wrapper">
          <NationalEmblem className="logo" />
          <div className="name-wrapper">
            <div className="name-wrapper-title">
              JANANI
            </div>
            <div className="name-wrapper-subtext">
              Journey of Antenatal, Natal and Neonatal Integrated Care
            </div>
            <div className="name-wrapper-subtext" style={{ fontWeight: 'bold' }}>Sehat ke Sath, Every Step of Care</div>
          </div>
        </div>
        <div className="view-route">
          <BreadcrumbComponent
            breadcrumbItemName={[
              { value: page, label: 'User Management' },
              { value: page, label: 'User Profile' },
            ]}
          />
        </div>
      </header>
      <main className="view-content">
        <div className="view-profile-buttons">
          <div className="view-profile">
            <CommonHamburgar>
              <LeftNavBar
                navItems={tabs}
                currentTab={currentTab}
                handleNavClick={setCurrentTab}
              />
            </CommonHamburgar>
            <Link to={'/user-management'}>
              <Button
                onClick={handleBack}
                disabled={false}
                id=""
                buttonName={''}
                colorType={'verticalbackbutton'}
                icon={<BackArrowsvg />}
                iconPosition={'left'}
              />
            </Link>
              <img
                className="profile-picture"
                src={imageURL|| profilePic}
                alt='Profile Image'
              />
            <div className="name-type">
              <div className="name">{`${user.first_name.value}`}</div>
              <div className="type">{`${user.usertype_name} > ${user.roles}`}</div>
            </div>
            <BadgesComponent
              className="user-status"
              badgeName={user.user_status}
              variant={user.user_status === 'Active' ? "success" : "warning"}
              badgeType="case5"
            />
          </div>
          {currentTab !== 'Health Provider Maintenance' && <div className="cancel-edit">
          {flow!=='view'&&<Button
              onClick={() => {
                navigate(-1);
                setCurrentTab('Overview');
              }}
              disabled={false}
              id="cancel"
              buttonName={'Cancel'}
              colorType={'save'}
              icon={''}
              iconPosition={'right'}

            />}
            <Button
              onClick={() => {
                setCurrentTab('Overview');
                flow === 'view' ? navigate(`/user-management/edit/${user.user_id}`, {
                  state: JSON.stringify(user),
                }) : updateHandlerUpdate();

              }}
              disabled={false}
              id={flow === 'view' ? 'edit-details' : 'save-details'}
              buttonName={buttonName}
              colorType={'primary'}
              icon={icon}
              iconPosition={'right'}
            />
          </div>}
        </div>
        <div className="content">
          <LeftNavBar
            navItems={tabs}
            currentTab={currentTab}
            handleNavClick={setCurrentTab}
          />
          <div className="tab-content">
            {(currentTab === 'Overview' ? flow === 'view' ? <OverView user={user} setUser={setUser} flow={flow} handleChange={handleChange} /> :
              <UserManagementUpdate  ref={childRef} handleChange={handleChange} user={user} flow={flow} /> :
              (currentTab === 'Health Provider Maintenance' && (user.usertype_name === 'Facility Level User' || user.usertype_name === 'Field Level User')) ?
                <UserManagementHealthProvider /> : currentTab === 'Privileges' ? <PrivilegeDetails flow={flow} page={page} roleDetails={roleDetails}/> : currentTab === 'Credentials' ?
                  <Credentials  user={user} flow={flow} page={page} /> : <></>)
            }
          </div>
        </div>
      </main>
    </div>
  );
};
export default UserViewComponent;
